import * as actionTypes from "./activityActions";

export const clickTile = (tileName) => {
  return {
    type: actionTypes.TILE_CLICKED,
    tileName: tileName,
  };
};
